module.exports = "/images/badge_status_protected.png?8993c8f6bf624b46465f372e0f021b02";